import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('xs')]: {
    height: 37,
  },
  [theme.breakpoints.up('xl')]: {
    height: 24,
  },
  backgroundColor: theme.palette.coolGrey[100],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  margin: 0,
  padding: theme.spacing(1),
}));
